export const DOCUMENT_TYPES = {
  summary: {
    name: "議事録",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  "system-proposal": {
    name: "システム概要書",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  estimation: {
    name: "概算工数見積書",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  "cost-effectiveness": {
    name: "費用対効果",
    creditUsage: {
      generate: 0,
      export: 0,
    },
  },
  "functional-requirements": {
    name: "機能要件書",
    creditUsage: {
      generate: 3,
      export: 0,
    },
  },
  "non-functional-requirements": {
    name: "非機能要件書",
    creditUsage: {
      generate: 3,
      export: 0,
    },
  },
  workflow: {
    name: "業務フロー図",
    creditUsage: {
      generate: 3,
      export: 0,
    },
  },
  "plugin-proposal": {
    name: "プラグイン提案書",
    creditUsage: {
      generate: 3,
      export: 0,
    },
  },
  "app-design": {
    name: "アプリ設計書",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  "field-design": {
    name: "フィールド設計書",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  "entity-relationship": {
    name: "ER図",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  "system-architecture": {
    name: "システム構成図",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
  "customize-specification": {
    name: "カスタマイズ仕様書",
    creditUsage: {
      generate: 5,
      export: 0,
    },
  },
} as const;

// 型定義のエクスポート（~/interface/document から再エクスポート）
export type { DocumentType } from "~/interface/document";

export {
  DOCUMENT_TYPES_LIST,
  documentNameMap,
  getDocumentTypeName,
} from "~/interface/document";
